import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import ExchangeRate from '../entities/exchangeRate';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import CurrencyMarkup from '../entities/currencyMarkup';

interface ExchangeRateState extends ListState<ExchangeRate> {
  exchangeRate: ExchangeRate;
  editExchangeRate: ExchangeRate;
}

class ExchangeRateMutations extends ListMutations<ExchangeRate> {}

class ExchangeRateModule extends ListModule<
  ExchangeRateState,
  any,
  ExchangeRate
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<ExchangeRate>(),
    loading: false,
    editExchangeRate: new ExchangeRate(),
    selectExchangeRate: new ExchangeRate(),
  };
  actions = {
    async selectExchangeRate(
      context: ActionContext<ExchangeRateState, any>,
      payload: any
    ) {
      context.state.editExchangeRate = payload.data;
    },

    async saveExchangeRate(
      context: ActionContext<ExchangeRateState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Content/SaveExchangeRate',
        payload.data
      );

      let page = reponse.data.result as PageResult<ExchangeRate>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },

    async addCurrencyMarkup(context: ActionContext<ExchangeRateState, any>, payload: any) {
      let response = await Ajax.post(
        '/api/services/app/Admin/AddCurrencyMarkup',
        payload.data
      );
        return response;
    },
    async updateExchangeRate(
      context: ActionContext<ExchangeRateState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Content/UpdateExchangeRate',
        payload.data
      );

      let page = reponse.data.result as PageResult<ExchangeRate>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getExchangeRates(
      context: ActionContext<ExchangeRateState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Content/GetExchangeRates',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<ExchangeRate>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getCurrencyMarkups(
      context: ActionContext<ExchangeRateState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Admin/GetCurrencyMarkups',
        payload.data
      );

      // context.state.loading=false;
      let result = reponse.data.result as PageResult<CurrencyMarkup>;
      return result;
    },
    async deleteExchangeRate(
      context: ActionContext<ExchangeRateState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Content/DeleteExchangeRate?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: ExchangeRateState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ExchangeRateState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const exchangeRateModule = new ExchangeRateModule();
export default exchangeRateModule;
